import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=99935a36&scoped=true&"
import script from "./NewsForm.vue?vue&type=script&lang=js&"
export * from "./NewsForm.vue?vue&type=script&lang=js&"
import style0 from "./NewsForm.vue?vue&type=style&index=0&id=99935a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99935a36",
  null
  
)

export default component.exports